
<template>

  <div>

    <div>Google Oauth</div>
    <div @click="handleClickGetAuth" :disabled="!isInit">get auth code</div>
    <div @click="handleClickSignIn" v-if="!isSignIn" :disabled="!isInit">signIn</div>
    <div @click="handleClickSignOut" v-if="isSignIn" :disabled="!isInit">signOout</div>
    <!-- <div v-show="!profile" id="g-signin2"></div>
    <div v-if="profile">
      <pre>{{ profile }}</pre>
      <button @click="signOut">Sign Out</button>
    </div> -->
  </div>

</template>

<script>

export default {
  name: 'Oauth2Google',
  // props: {
  //   data: {
  //     required: true,
  //     type: Array / Object,
  //     default: {}
  //   }
  // },
  data () {
    return {
      isInit: false,
      isSignIn: false

      // 640025228959-m61s85onj4jf15ul0t7hc72lpka1leim.apps.googleusercontent.com
      // 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

      // profile: null
    }
  },
  mounted () {
    // this.test()
    let that = this
    let checkGauthLoad = setInterval(function () {
      that.isInit = that.$gAuth.isInit
      that.isSignIn = that.$gAuth.isAuthorized
      if (that.isInit) clearInterval(checkGauthLoad)
    }, 1000)
    // this.test()
    // this.initGoogleAuth()
    // this.renderGoogleAuthButton()
  },
  methods: {
    async test () {
      const googleUser = await this.$gAuth.signIn()
      console.log('googleUser: ', googleUser)
    },

    async handleClickGetAuth () {
      try {
        const authCode = await this.$gAuth.getAuthCode()
        const response = await this.$http.post('http://your-backend-server.com/auth/google', { code: authCode, redirect_uri: 'postmessage' })
        console.log(response)
      } catch (error) {
        // On fail do something
      }
    },

    async handleClickSignIn () {
      try {
        const googleUser = await this.$gAuth.signIn()
        console.log('user', googleUser)
        this.isSignIn = this.$gAuth.isAuthorized
      } catch (error) {
        // On fail do something
        console.error(error)
        return null
      }
    },

    async handleClickSignOut () {
      try {
        await this.$gAuth.signOut()
        this.isSignIn = this.$gAuth.isAuthorized
      } catch (error) {
        // On fail do something
      }
    }

    // async test () {
    //   const googleUser = await this.$gAuth.signIn()
    //   console.log(googleUser)
    // }

    // onSignIn(user) {
    //   const profile = user.getBasicProfile();
    //   const fullName = profile.getName();
    //   const email = profile.getEmail();
    //   const imageUrl = profile.getImageUrl();
    //   this.profile = { fullName, email, imageUrl };
    // },
    // signOut() {
    //   var auth2 = window.gapi.auth2.getAuthInstance();
    //   auth2.signOut().then(() => {
    //     console.log("User signed out");
    //     this.profile = null;
    //   });
    // },
    // initGoogleAuth() {
    //   window.gapi.load("auth2", function () {
    //     window.gapi.auth2.init();
    //   });
    // },
    // renderGoogleAuthButton() {
    //   window.gapi.signin2.render("g-signin2", {
    //     onsuccess: this.onSignIn
    //   });
    // }
  }
}

</script>

<style scoped src="@/assets/css/form.css"></style>



// WEBPACK FOOTER //
// src/components/utils/form/inputs/Oauth2Google.vue